import React from 'react';
import { cn } from '../utils/helpers';

interface StatsCardProps {
  title: string;
  value: string | number;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  icon: React.ComponentType<{ className?: string }>;
  loading?: boolean;
}

export function StatsCard({ title, value, change, changeType = 'neutral', icon: Icon, loading }: StatsCardProps) {
  if (loading) {
    return (
      <div className="bg-white p-6 rounded-lg shadow loading-shimmer">
        <div className="h-6 w-24 bg-gray-200 rounded mb-2"></div>
        <div className="h-8 w-16 bg-gray-200 rounded mb-1"></div>
        <div className="h-4 w-20 bg-gray-200 rounded"></div>
      </div>
    );
  }

  const changeColorClass = {
    positive: 'text-green-600',
    negative: 'text-red-600',
    neutral: 'text-gray-500',
  }[changeType];

  return (
    <div className="bg-white p-6 rounded-lg shadow card-hover">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <Icon className="h-6 w-6 text-primary-600" />
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm font-medium text-gray-900">{title}</p>
          <div className="flex items-baseline">
            <p className="text-2xl font-bold text-gray-900">{value}</p>
          </div>
          {change && (
            <p className={cn('text-xs', changeColorClass)}>
              {change}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
